import { CircularProgress } from "@mui/material";
import { FunctionComponent } from "react";

export const ButtonProgress: FunctionComponent = () => (
  <CircularProgress size="1.2rem" />
);
